
const app = {
    state: {
        activeIndex: 1
    },
    mutations: {
        SET_ACTIVE: (state, id) => {
            state.activeIndex = id
        },
    },

    actions: {
        setActive({ commit },num) {
            commit('SET_ACTIVE', num)
        },
    }
}

export default app


// WEBPACK FOOTER //
// ./src/store/modules/app.js